<template>
  <transition name="slide-pageTransition" mode="out-in">
    <div class="wrapper">
      <h2>{{ fio }}</h2>
      <h2>Ваш номер договора: {{ document }}</h2>
      <h2>Срок действия договора истекает: {{ date }}</h2>
      <button class="btn danger" @click.prevent="logout">Выйти</button>
      <app-page title="Создайте заявку и мы свяжемся с вами">
        <template #header>
          <button class="btn primary" @click="modal = true">Создать</button>
        </template>

        <teleport to="body">
          <request-modal v-if="modal" title="Создать заявку" @close="modal = false">
            <request-body @created="modal = false"></request-body>
          </request-modal>
        </teleport>
      </app-page>
    </div>
  </transition>
</template>

<script>

import store from '@/store';
import {ref} from 'vue'
import {useRouter} from 'vue-router'
import {useStore} from 'vuex'
import AppPage from "@/components/backend/AppPage";
import RequestModal from "@/components/ui/RequestModal";
import RequestBody from "@/components/ui/RequestBody";

export default {
  components: {AppPage, RequestModal, RequestBody},
  setup() {
    const router = useRouter()
    const store = useStore()

    const fio = store._state.data.auth.loginData.name
    const document = store._state.data.auth.loginData.contract
    const date = store._state.data.auth.loginData.validity

    const modal = ref(false)

    return {

      fio,
      document,
      date,

       logout: () => {
        store.commit('auth/logout')
        store.dispatch('auth/logout',null, {root: true} )
        store.commit('clearMessage', null, {root:true})
        store.dispatch('setMessage', {
          value: 'Вы вышли из аккаунта',
          type: 'warning'
        }, {root: true})
        router.push('/')
      },
      modal,
    }
  }
}

</script>

<style scoped>

h2 {
  margin: 10px;
}

.wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}

button {
  cursor: pointer;
  margin: 15px;
}

@media (max-width: 400px) {
  h2 {
    font-size: 24px;
    text-align: center;
  }
}


</style>